import React from "react";
import ReactDOM from "react-dom";
import App from "./redux/rootRedux";
import i18n from "configs/i18n";

// Force Japanese language and remove any stored language preference
localStorage.removeItem("i18nextLng");
i18n.changeLanguage("ja");

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
